import { faker } from '@faker-js/faker'
import { http, HttpResponse } from 'msw'

import { states } from '@/shared/resources/states'

export const mockGetCities = http.get(
  '/api/booking/v1/locales/cities',
  ({ request }) => {
    const url = new URL(request.url)
    const searchParams = url.searchParams

    const data: {
      cityId: number
      cityName: string
      stateName: string
      stateSymbol: string
      countryName: string
      countrySymbol: string
      iata: string
    }[] = Array.from({ length: 20 }).map(() => {
      return {
        cityId: faker.number.int({ min: 1000, max: 9999 }),
        cityName: faker.location.city(),
        countryName: faker.location.country(),
        countrySymbol: faker.location.countryCode(),
        stateName: faker.location.state(),
        iata: faker.string.alphanumeric(3),
        stateSymbol:
          searchParams.get('stateSymbol') ??
          faker.helpers.arrayElement(states.map((state) => state.value)),
      }
    })

    return HttpResponse.json({ data }, { status: 200 })
  },
)
